export const GER_NAV_ITEMS = [
  { id: "overview", label: "Executive Overview" },
  { id: "stage", label: "Stage-wise GER" },
  { id: "district", label: "District Performance" },
  { id: "gender", label: "Gender Equity" },
  { id: "transition", label: "Transition & Retention" },
  { id: "population", label: "Population vs Enrolment" },
  { id: "risk", label: "Risk & Intervention" },
  { id: "action", label: "Action Tracker" },
];

export const GER_TAB_ITEMS = GER_NAV_ITEMS;
